import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_RECIPES](state, data) {
    state.allRecipes = data
  },
}
